import pino from 'pino';
import { env } from '@hen-site/env';
import { censorLoggedValue } from './telemetryDenylist';

export const loggerContext = {
  appVersion: env.appVersion,
};

type CreateLoggerArgs = {
  options?: pino.LoggerOptions;
  destination?: pino.DestinationStream;
};

let loggerSingleton: pino.Logger | undefined;
export const createLogger = ({
  options = {},
  destination,
}: CreateLoggerArgs) => {
  if (!loggerSingleton) {
    const callerLogMethod = options.hooks?.logMethod;
    loggerSingleton = pino(
      {
        ...options,
        level: options.level ?? env.logLevel ?? 'info',
        hooks: {
          ...options.hooks,
          logMethod(args, method, level) {
            // Pino types this argument list as a union of call signatures.
            const censored = Array.from(args, (arg) =>
              censorLoggedValue(arg),
            ) as Parameters<pino.LogFn>;
            if (callerLogMethod) {
              callerLogMethod.call(this, censored, method, level);
              return;
            }
            method.apply(this, censored);
          },
        },
      },
      destination,
    ).child(loggerContext);
  }
  return loggerSingleton;
};
